import React, { Component } from "react";

import { Row, Col } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import LazyLoad from "react-lazyload";

// CSS Files
import "../../Fonts/Fonts.css";
import "../../Statics/Common/Footer.css";

const footerText = {
  fontFamily: "IranSans",
  color: "#fff",
  fontSize: ".8em",
  textAlign: "justify",
  direction: "rtl",
  marginTop: "-5px",
};
const footerTextTablet = {
  fontFamily: "IranSans",
  color: "#fff",
  fontSize: ".75em",
  textAlign: "right",
  direction: "rtl",
  marginTop: "15px",
};
const footerTextMobile = {
  fontFamily: "IranSans",
  color: "#fff",
  fontSize: ".75em",
  textAlign: "center",
  direction: "rtl",
  marginTop: "15px",
};
const footerLinkMobile = {
  fontFamily: "IranSans",
  color: "#fff",
  fontSize: ".7em",
  textAlign: "right",
  direction: "rtl",
  marginTop: "5px",
};
const Footer = (props) => {
  return props.size === "laptopdesktop" ? (
    <div>
      <div className="footerBackground">
        <Row>
          <Col span={2}></Col>
          <Col span={5}>
            <Margin top={5}></Margin>
            <Row>
              <Col span={12}>
                <Center>
                  <LazyLoad>
                    <img
                      style={{ width: "75%" }}
                      src={require("../../Imgs/Common/namad2.png")}
                    />
                  </LazyLoad>
                </Center>
              </Col>
              <Col span={12}>
                <LazyLoad>
                  <img
                    style={{ width: "75%" }}
                    src={require("../../Imgs/Common/namad4.png")}
                  />
                </LazyLoad>
              </Col>
            </Row>
            <Margin top={2}></Margin>
            <Row>
              <Col span={12}>
                <a target="_blank" href="https://trustseal.enamad.ir/?id=542977&Code=dmKtlb9adgtFnlrGA2BefFurY2AFtE9g"><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=542977&Code=dmKtlb9adgtFnlrGA2BefFurY2AFtE9g' alt='' style={{cursor:"pointer" , width:"60%"}} code='dmKtlb9adgtFnlrGA2BefFurY2AFtE9g'/></a>

              </Col>
              <Col span={12}>
                <LazyLoad>
                  <img
                    style={{ width: "70%" }}
                    src={require("../../Imgs/Common/namad3.png")}
                  />
                </LazyLoad>
              </Col>
            </Row>
          </Col>
          <Col span={5}>
            <Margin top={4}></Margin>
            <p
              style={{
                fontFamily: "IranSans",
                color: "#ffffff",
                direction: "rtl",
                textAlign: "right",
                fontSize: "1em",
              }}
            >
              <strong>راه های ارتباطی</strong>
            </p>
            <Margin top={4}></Margin>
            <p style={footerText}>
            تهران، یوسف آباد،خیابان سیدجمال الدین اسدآبادی،نبش کوچه چهارم پلاک ۴۴ ساختمان ایرانیان پوشش 

            </p>

            <p style={footerText}>تلفن درخواست کارشناس: ۱۴۰۱ بدون کد</p>

            <p style={footerText}>مرکز اعلام خسارات: 41558-۰۲۱</p>

            <p style={footerText}>تلفن درخواست امداد خودرو: ۴۱۵۵۹-۰۲۱</p>

            <p style={footerText}>
              تلفن ستاد: ( هزار خط ) 999 الی 84229000-021
            </p>
            <p style={footerText}>ثبت‌نام کلاس‌های آموزشی: ۷۵۳۳۱-۰۲۱</p>
          </Col>
          <Col span={5} style={{ direction: "rtl", textAlign: "right" }}>
            <Margin top={4}></Margin>
            <p
              style={{
                fontFamily: "IranSans",
                color: "#ffffff",
                direction: "rtl",
                textAlign: "right",
                fontSize: "1em",
              }}
            >
              <strong>پیوندها</strong>
            </p>
            <Margin top={4}></Margin>
            <Row style={{ marginTop: "5px" }}>
              <a
                className="footerItemBorder"
                href="https://www.centinsur.ir/"
                target="_blank"
                style={footerText}
              >
                بیمه مرکزی
              </a>
            </Row>
            <Row style={{ marginTop: "10px" }}>
              <a
                className="footerItemBorder"
                href="http://www.biif.ir/"
                target="_blank"
                style={footerText}
              >
                صندوق تامین خسارت بدنی
              </a>
            </Row>
            <Row style={{ marginTop: "10px" }}>
              <a
                className="footerItemBorder"
                href="http://www.irc.ac.ir/fa-IR/Irc/1/page/%D8%B5%D9%81%D8%AD%D9%87-%D8%A7%D8%B5%D9%84%DB%8C"
                target="_blank"
                style={{
                  fontFamily: "IranSans",
                  color: "#fff",
                  fontSize: ".8em",
                }}
              >
                پژوهشکده بیمه
              </a>
            </Row>
            <Row style={{ marginTop: "10px" }}>
              <a
                className="footerItemBorder"
                href="http://www.sbi.ir/"
                target="_blank"
                style={footerText}
              >
                سندیکای بیمه گران
              </a>
            </Row>

            <Row style={{ marginTop: "10px" }}>
              <a
                className="footerItemBorder"
                href="https://www.lossadjuster.ir/"
                target="_blank"
                style={footerText}
              >
                انجمن ارزیابان خسارت صنعت بیمه
              </a>
            </Row>
            <Row style={{ marginTop: "10px" }}>
              <a
                className="footerItemBorder"
                href="http://www.moraghebbime.ir/"
                target="_blank"
                style={footerText}
              >
                خبرگزاری بیمه ای
              </a>
            </Row>
          </Col>
          <Col span={5} style={{ direction: "rtl", textAlign: "right" }}>
            <Margin top={4}></Margin>
            <p
              style={{
                fontFamily: "IranSans",
                color: "#ffffff",
                direction: "rtl",
                textAlign: "right",
                fontSize: "1em",
              }}
            >
              <strong>دسترسی سریع</strong>
            </p>
            <Margin top={4}></Margin>
            <Row style={{ marginTop: "10px" }}>
              <a className="footerItemBorder" href="/" style={footerText}>
                صفحه نخست
              </a>
            </Row>
            <Row style={{ marginTop: "10px" }}>
              <a
                className="footerItemBorder"
                onClick={() => props.history.push("/aboutus")}
                style={footerText}
              >
                درباره ما
              </a>
            </Row>
            <Row style={{ marginTop: "10px" }}>
              <a
                className="footerItemBorder"
                onClick={() => props.history.push("/ourcompanies")}
                style={footerText}
              >
                شرکت های ما
              </a>
            </Row>
            <Row style={{ marginTop: "10px" }}>
              <a
                className="footerItemBorder"
                onClick={() => props.history.push("/ourservices/1")}
                style={footerText}
              >
                محصولات و نوآوری
              </a>
            </Row>
            <Row style={{ marginTop: "10px" }}>
              <a
                className="footerItemBorder"
                onClick={() => props.history.push("/responsibility")}
                style={footerText}
              >
                مسئولیت های اجتماعی
              </a>
            </Row>
            <Row style={{ marginTop: "10px" }}>
              <a
                className="footerItemBorder"
                onClick={() => props.history.push("/contactus")}
                style={footerText}
              >
                ارتباط با ما
              </a>
            </Row>
          </Col>
          <Col span={2}></Col>
        </Row>
      </div>
      <Row style={{ backgroundColor: "#16364C" }}>
        <Col span={4}></Col>
        <Col span={16} style={{ paddingTop: "15px" }}>
          <Center>
            <p
              style={{
                fontFamily: "IranSans",
                color: "#ffffff",
                fontSize: ".7em",
                direction: "rtl",
                textAlign: "center",
              }}
            >
              کلیه حقوق این سایت متعلق به شرکت نرم افزاری سناپ وابسته به
              ایرانیان پوشش می ‌باشد.
            </p>
          </Center>
        </Col>
        <Col span={4}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div>
      <div>
        <div className="footerBackground">
          <Row>
            <Col span={1}></Col>
            <Col span={5}>
              <Margin top={5}></Margin>
              <Row>
                <Col span={12}>
                  <Center>
                    <LazyLoad>
                      <img
                        style={{ width: "90%" }}
                        src={require("../../Imgs/Common/namad2.png")}
                      />
                    </LazyLoad>
                  </Center>
                </Col>
                <Col span={12}>
                  <LazyLoad>
                    <img
                      style={{ width: "90%" }}
                      src={require("../../Imgs/Common/namad4.png")}
                    />
                  </LazyLoad>
                </Col>
              </Row>
              <Margin top={2}></Margin>
              <Row>
                <Col span={12}>
                <a target="_blank" href="https://trustseal.enamad.ir/?id=542977&Code=dmKtlb9adgtFnlrGA2BefFurY2AFtE9g"><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=542977&Code=dmKtlb9adgtFnlrGA2BefFurY2AFtE9g' alt='' style={{cursor:"pointer" , width:"60%"}} code='dmKtlb9adgtFnlrGA2BefFurY2AFtE9g'/></a>

                </Col>
                <Col span={12}>
                  <LazyLoad>
                    <img
                      style={{ width: "90%" }}
                      src={require("../../Imgs/Common/namad3.png")}
                    />
                  </LazyLoad>
                </Col>
              </Row>
            </Col>
            <Col span={6}>
              <Margin top={4}></Margin>
              <p
                style={{
                  fontFamily: "IranSans",
                  color: "#ffffff",
                  direction: "rtl",
                  textAlign: "right",
                  fontSize: ".9em",
                }}
              >
                <strong>راه های ارتباطی</strong>
              </p>
              <Margin top={3}></Margin>
              <p style={footerTextTablet}>
              تهران، یوسف آباد،خیابان سیدجمال الدین اسدآبادی،نبش کوچه چهارم پلاک ۴۴ ساختمان ایرانیان پوشش 
              </p>

              <p style={footerTextTablet}>تلفن درخواست کارشناس: ۱۴۰۱ بدون کد</p>

              <p style={footerTextTablet}>مرکز اعلام خسارات: 41558-۰۲۱</p>

              <p style={footerTextTablet}>
                تلفن درخواست امداد خودرو: ۴۱۵۵۹-۰۲۱
              </p>

              <p style={footerTextTablet}>
                تلفن ستاد: ( هزار خط ) 999 الی 84229000-021
              </p>
              <p style={footerTextTablet}>ثبت‌نام کلاس‌های آموزشی: ۷۵۳۳۱-۰۲۱</p>
            </Col>
            <Col span={6} style={{ direction: "rtl", textAlign: "right" }}>
              <Margin top={4}></Margin>
              <p
                style={{
                  fontFamily: "IranSans",
                  color: "#ffffff",
                  direction: "rtl",
                  textAlign: "right",
                  fontSize: ".9em",
                }}
              >
                <strong>پیوندها</strong>
              </p>
              <Margin top={3}></Margin>
              <Row style={{ marginTop: "5px" }}>
                <a
                  className="footerItemBorder"
                  href="https://www.centinsur.ir/"
                  target="_blank"
                  style={footerLinkMobile}
                >
                  بیمه مرکزی
                </a>
              </Row>
              <Row style={{ marginTop: "5px" }}>
                <a
                  className="footerItemBorder"
                  href="http://www.biif.ir/"
                  target="_blank"
                  style={footerLinkMobile}
                >
                  صندوق تامین خسارت بدنی
                </a>
              </Row>
              <Row style={{ marginTop: "5px" }}>
                <a
                  className="footerItemBorder"
                  href="http://www.irc.ac.ir/fa-IR/Irc/1/page/%D8%B5%D9%81%D8%AD%D9%87-%D8%A7%D8%B5%D9%84%DB%8C"
                  target="_blank"
                  style={footerLinkMobile}
                >
                  پژوهشکده بیمه
                </a>
              </Row>
              <Row style={{ marginTop: "5px" }}>
                <a
                  className="footerItemBorder"
                  href="http://www.sbi.ir/"
                  target="_blank"
                  style={footerLinkMobile}
                >
                  سندیکای بیمه گران
                </a>
              </Row>

              <Row style={{ marginTop: "5px" }}>
                <a
                  className="footerItemBorder"
                  href="https://www.lossadjuster.ir/"
                  target="_blank"
                  style={footerLinkMobile}
                >
                  انجمن ارزیابان خسارت صنعت بیمه
                </a>
              </Row>
              <Row style={{ marginTop: "5px" }}>
                <a
                  className="footerItemBorder"
                  href="http://www.moraghebbime.ir/"
                  target="_blank"
                  style={footerLinkMobile}
                >
                  خبرگزاری بیمه ای
                </a>
              </Row>
            </Col>
            <Col span={5} style={{ direction: "rtl", textAlign: "right" }}>
              <Margin top={4}></Margin>
              <p
                style={{
                  fontFamily: "IranSans",
                  color: "#ffffff",
                  direction: "rtl",
                  textAlign: "right",
                  fontSize: ".9em",
                }}
              >
                <strong>دسترسی سریع</strong>
              </p>
              <Margin top={3}></Margin>
              <Row style={{ marginTop: "5px" }}>
                <a
                  className="footerItemBorder"
                  href="/"
                  style={footerLinkMobile}
                >
                  صفحه نخست
                </a>
              </Row>
              <Row style={{ marginTop: "5px" }}>
                <a
                  className="footerItemBorder"
                  onClick={() => props.history.push("/aboutus")}
                  style={footerLinkMobile}
                >
                  درباره ما
                </a>
              </Row>
              <Row style={{ marginTop: "5px" }}>
                <a
                  className="footerItemBorder"
                  onClick={() => props.history.push("/ourcompanies")}
                  style={footerLinkMobile}
                >
                  شرکت های ما
                </a>
              </Row>
              <Row style={{ marginTop: "5px" }}>
                <a
                  className="footerItemBorder"
                  onClick={() => props.history.push("/ourservices/1")}
                  style={footerLinkMobile}
                >
                  محصولات و نوآوری
                </a>
              </Row>
              <Row style={{ marginTop: "5px" }}>
                <a
                  className="footerItemBorder"
                  onClick={() => props.history.push("/responsibility")}
                  style={footerLinkMobile}
                >
                  مسئولیت های اجتماعی
                </a>
              </Row>
              <Row style={{ marginTop: "5px" }}>
                <a
                  className="footerItemBorder"
                  onClick={() => props.history.push("/contactus")}
                  style={footerLinkMobile}
                >
                  تماس با ما
                </a>
              </Row>
            </Col>
            <Col span={1}></Col>
          </Row>
        </div>
        <Row style={{ backgroundColor: "#16364C" }}>
          <Col span={4}></Col>
          <Col span={16} style={{ paddingTop: "15px" }}>
            <Center>
              <p
                style={{
                  fontFamily: "IranSans",
                  color: "#ffffff",
                  fontSize: ".7em",
                  direction: "rtl",
                  textAlign: "center",
                }}
              >
                کلیه حقوق این سایت متعلق به شرکت نرم افزاری سناپ وابسته به
                ایرانیان پوشش می ‌باشد.
              </p>
            </Center>
          </Col>
          <Col span={4}></Col>
        </Row>
      </div>
    </div>
  ) : (
    <div>
      <div className="footerBackground">
        <Row>
          <Col span={2}></Col>
          <Col span={20}>
            <p style={footerTextMobile}>
            تهران، یوسف آباد،خیابان سیدجمال الدین اسدآبادی،نبش کوچه چهارم پلاک ۴۴ ساختمان ایرانیان پوشش 
            </p>
          </Col>
          <Col span={2}></Col>
        </Row>
        <Center>
          <p style={footerText}>تلفن درخواست کارشناس: ۱۴۰۱ بدون کد</p>
        </Center>
        <Center>
          <p style={footerText}>مرکز اعلام خسارات: 41558-۰۲۱</p>
        </Center>
        <Center>
          <p style={footerText}>تلفن درخواست امداد خودرو: ۴۱۵۵۹-۰۲۱</p>
        </Center>
        <Center>
          <p style={footerText}>تلفن ستاد: ( هزار خط ) 999 الی 84229000-021</p>
        </Center>
        <Center>
          <p style={footerText}>ثبت‌نام کلاس‌های آموزشی: ۷۵۳۳۱-۰۲۱</p>
        </Center>

        <Row>
          <Col span={1}></Col>
          <Col span={11}>
            <Row style={{ direction: "rtl", textAlign: "right" }}>
              <a
                className="footerItemBorder"
                href="https://www.centinsur.ir/"
                target="_blank"
                style={footerLinkMobile}
              >
                بیمه مرکزی
              </a>
            </Row>
            <Row style={{ direction: "rtl", textAlign: "right" }}>
              <a
                className="footerItemBorder"
                href="http://www.biif.ir/"
                target="_blank"
                style={footerLinkMobile}
              >
                صندوق تامین خسارت بدنی
              </a>
            </Row>
            <Row style={{ direction: "rtl", textAlign: "right" }}>
              <a
                className="footerItemBorder"
                href="http://www.irc.ac.ir/fa-IR/Irc/1/page/%D8%B5%D9%81%D8%AD%D9%87-%D8%A7%D8%B5%D9%84%DB%8C"
                target="_blank"
                style={footerLinkMobile}
              >
                پژوهشکده بیمه
              </a>
            </Row>
            <Row style={{ direction: "rtl", textAlign: "right" }}>
              <a
                className="footerItemBorder"
                href="http://www.sbi.ir/"
                target="_blank"
                style={footerLinkMobile}
              >
                سندیکای بیمه گران
              </a>
            </Row>

            <Row style={{ direction: "rtl", textAlign: "right" }}>
              <a
                className="footerItemBorder"
                href="https://www.lossadjuster.ir/"
                target="_blank"
                style={footerLinkMobile}
              >
                انجمن ارزیابان خسارت صنعت بیمه
              </a>
            </Row>
            <Row style={{ direction: "rtl", textAlign: "right" }}>
              <a
                className="footerItemBorder"
                href="http://www.moraghebbime.ir/"
                target="_blank"
                style={footerLinkMobile}
              >
                خبرگزاری بیمه ای
              </a>
            </Row>
          </Col>
          <Col span={11}>
            <Row style={{ direction: "rtl", textAlign: "right" }}>
              <a className="footerItemBorder" href="/" style={footerLinkMobile}>
                صفحه نخست
              </a>
            </Row>
            <Row style={{ direction: "rtl", textAlign: "right" }}>
              <a
                className="footerItemBorder"
                onClick={() => props.history.push("/aboutus")}
                style={footerLinkMobile}
              >
                درباره ما
              </a>
            </Row>
            <Row style={{ direction: "rtl", textAlign: "right" }}>
              <a
                className="footerItemBorder"
                onClick={() => props.history.push("/ourcompanies")}
                style={footerLinkMobile}
              >
                شرکت های ما
              </a>
            </Row>
            <Row style={{ direction: "rtl", textAlign: "right" }}>
              <a
                className="footerItemBorder"
                onClick={() => props.history.push("/ourcompanies/1")}
                style={footerLinkMobile}
              >
                محصولات و نوآوری
              </a>
            </Row>
            <Row style={{ direction: "rtl", textAlign: "right" }}>
              <a
                className="footerItemBorder"
                onClick={() => props.history.push("/responsibility")}
                style={footerLinkMobile}
              >
                مسئولیت های اجتماعی
              </a>
            </Row>
            <Row style={{ direction: "rtl", textAlign: "right" }}>
              <a
                className="footerItemBorder"
                onClick={() => props.history.push("/contactus")}
                style={footerLinkMobile}
              >
                تماس با ما
              </a>
            </Row>
          </Col>
          <Col span={1}></Col>
        </Row>
        <Margin top={3}></Margin>
        <Row>
          <Col span={6}>
          <a target="_blank" href="https://trustseal.enamad.ir/?id=542977&Code=dmKtlb9adgtFnlrGA2BefFurY2AFtE9g"><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=542977&Code=dmKtlb9adgtFnlrGA2BefFurY2AFtE9g' alt='' style={{cursor:"pointer" , width:"60%"}} code='dmKtlb9adgtFnlrGA2BefFurY2AFtE9g'/></a>

          </Col>
          <Col span={6}>
            <Center>
              <LazyLoad>
                <img
                  style={{ width: "75%" }}
                  src={require("../../Imgs/Common/namad3.png")}
                />
              </LazyLoad>
            </Center>
          </Col>
          <Col span={6}>
            <Center>
              <LazyLoad>
                <img
                  style={{ width: "75%" }}
                  src={require("../../Imgs/Common/namad2.png")}
                />
              </LazyLoad>
            </Center>
          </Col>
          <Col span={6}>
            <Center>
              <LazyLoad>
                <img
                  style={{ width: "75%" }}
                  src={require("../../Imgs/Common/namad4.png")}
                />
              </LazyLoad>
            </Center>
          </Col>
        </Row>
      </div>
      <Row style={{ backgroundColor: "#16364C" }}>
        <Col span={24} style={{ paddingTop: "15px" }}>
          <Center>
            <p
              style={{
                fontFamily: "IranSans",
                color: "#ffffff",
                fontSize: ".6em",
                direction: "rtl",
                textAlign: "center",
              }}
            >
              کلیه حقوق این سایت متعلق به شرکت نرم افزاری سناپ وابسته به
              ایرانیان پوشش می ‌باشد.
            </p>
          </Center>
        </Col>
      </Row>
    </div>
  );
};

export default Footer;
